import { getAddress } from "viem"

export const vaults = new Map([
  [
    getAddress("0xE220d93e73D22e72Cb3f7B2496B4c2e6DfEd8B72"),
    {
      name: "Ether.fi WETH",
      description: "Component of the Ether.fi Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x5097DaacD8198a164257B6AAB66951323e53EE53"),
    {
      name: "Ether.fi WEETH",
      description: "Component of the Ether.fi Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xfeE02E3904DfcF323851163E3b8847952f168b2e"),
    {
      name: "Ether.fi USDT0",
      description: "Component of the Ether.fi Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x87Ca725845824903B29a03ADFDF1548Cd1D30a4f"),
    {
      name: "Ethena sUSDe",
      description: "Component of the Ethena Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x36313192157C38A16e197f48c80346849AE3957A"),
    {
      name: "Ethena USDe",
      description: "Component of the Ethena Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xB0004aD99F0e383cC413bA69ACff7c229D930112"),
    {
      name: "Ethena USDT0",
      description: "Component of the Ethena Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x767d33217e7d2670695FfE2a104548B780f4F5d8"),
    {
      name: "K3 Capital USDai sUSDai",
      description: "Component of the K3 Capital USDai Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0xAADEA03f6D6F198Bdc9229bD8113aceD19031773"),
    {
      name: "K3 Capital USDai USDai",
      description: "Component of the K3 Capital USDai Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0x141A6f77ca186861BFB323b07012e80Ef4e09041"),
    {
      name: "K3 Capital USDai USDT0",
      description: "Component of the K3 Capital USDai Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0x79C86345c5132465DdebB7dC90de0f826Fb905b1"),
    {
      name: "Plasma WXPL",
      description: "Component of the Plasma Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x969a9d7e07Dd584e5b989FE63ac202c4C2372Fd4"),
    {
      name: "Plasma ENA",
      description: "Component of the Plasma Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x7f801a8f69C9D9BA52aF27A8fADde56FC33F9267"),
    {
      name: "Plasma USDT0",
      description: "Component of the Plasma Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x5398657d46499D31863A404bbedc738bDa812424"),
    {
      name: "Maple syrupUSDT",
      description: "Component of the Maple Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xFA00aBfF8E404B4Fe939115409035F708a109842"),
    {
      name: "Maple USDT0",
      description: "Component of the Maple Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xAc40D41aB11b0eb991a7D34D55DbDbB7849e92EF"),
    {
      name: "Resolv wstUSR wstUSR",
      description: "Component of the Resolv wstUSR Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x2beBDc03D4268247c205ECB6926332221EC612AC"),
    {
      name: "Resolv wstUSR USR",
      description: "Component of the Resolv wstUSR Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x4718484ac9dc07fbbC078561e8f8Ef29e2a369CD"),
    {
      name: "Resolv wstUSR USDT0",
      description: "Component of the Resolv wstUSR Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x0a39a99f1639a9e26ED9F7c096165A41FDEb5E63"),
    {
      name: "Resolv RLP RLP",
      description: "Component of the Resolv RLP Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xbd2D9A3c34f866387a371035dc94Cbe94759E6d8"),
    {
      name: "Resolv RLP USR",
      description: "Component of the Resolv RLP Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x538f01e0BA3cf3aB5b3837A0d138a3F67b9b8235"),
    {
      name: "Resolv RLP USDT0",
      description: "Component of the Resolv RLP Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x57c582346B7d49A46Af3745A8278917D1c1311b8"),
    {
      name: "TelosC Stream USDT0",
      description: "Component of the TelosC Stream Market",
      entity: "telosc",
    },
  ],
  [
    getAddress("0x138c289Bb8b855CF271305C8bcf91DC31Ba30194"),
    {
      name: "TelosC Stream xUSD",
      description: "Component of the TelosC Stream Market",
      entity: "telosc",
    },
  ],
  [
    getAddress("0x8Cd0DE6204176600918dA79eC70d0d9F4c2588e3"),
    {
      name: "Re7 Labs USDT0",
      description: "Component of the Re7 Labs USDT0 Market",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x36e62e73DF0fE8e68280a93AD2F2d20CA25D0eF3"),
    {
      name: "Re7 Labs USDe",
      description: "Component of the Re7 Labs USDe Market",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xa61dcB570c7C728F992417bf20e8F56f2669A46C"),
    {
      name: "Re7 Labs sUSDe",
      description: "Component of the Re7 Labs USDe Market",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x7760dBA44A3b9dC740F8Ac3e49AFb66f1EC46834"),
    {
      name: "Re7 Labs WETH",
      description: "Component of the Re7 Labs WETH Market",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x729b92Cfea63CB238199eA61a01eA510D80fa444"),
    {
      name: "Re7 Labs XAUt",
      description: "Component of the Re7 Labs USDT0 Market",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xa4a52AF57D8FD82FC827E5E400007ab65CEf271b"),
    {
      name: "Re7 Labs weETH",
      description: "Component of the Re7 Labs WETH Market",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xF510385f5D74256bC677fbBA4e0e3079bE245Bd2"),
    {
      name: "Edge UltraYield sUSDe",
      description:
        "sUSDe vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0x230FB94b27da4e18f2eB6b66498aB3e9c860FAcD"),
    {
      name: "Edge UltraYield syrupUSDT",
      description:
        "syrupUSDT vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0xA467Ad3929E8FFdfD955f32756EC8b1522274eF2"),
    {
      name: "Edge UltraYield USDe",
      description:
        "USDe vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0xd3da8d58De01C99d9bB971cA284B89a2bb60798a"),
    {
      name: "Edge UltraYield USDT0",
      description:
        "USDT0 vault collateralized by other vaults in the Edge UltraYield Cluster.",
      entity: "edge-capital",
    },
  ],
  [
    getAddress("0x75C4D639067ddAf77f6BEc440e68DDdFab2C47eE"),
    {
      name: "Frontier PT-USDe PT",
      description: "Component of the Frontier PT-USDe Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x35b6f39affA0020c1736cdC764287bfd32Ee4324"),
    {
      name: "Frontier PT-USDe USDe",
      description: "Component of the Frontier PT-USDe Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x0D10591241F67449102ACF05CD9c480CfE43154c"),
    {
      name: "Frontier PT-USDe USDT0",
      description: "Component of the Frontier PT-USDe Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xc3fF7A69A232239ce306dB50d63Ab2737053e24C"),
    {
      name: "Frontier PT-sUSDe PT",
      description: "Component of the Frontier PT-sUSDe Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xd9e36ad27AfF5bBF2c65026462d45DF093554D38"),
    {
      name: "Frontier PT-sUSDe sUSDe",
      description: "Component of the Frontier PT-sUSDe Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x8073b76bBd1B40F1Fb2b6AEf7A920B1914Bb86AB"),
    {
      name: "Frontier PT-sUSDe USDT0",
      description: "Component of the Frontier PT-sUSDe Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x0bB995211462d10495136C6F2eCc367435481c2d"),
    {
      name: "Frontier PT-syrupUSDT PT",
      description: "Component of the Frontier PT-syrupUSDT Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xf0A1bDf7e678144702feC359fa1A0eb50b0B8845"),
    {
      name: "Frontier PT-syrupUSDT syrupUSDT",
      description: "Component of the Frontier PT-syrupUSDT Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x5DccE5f1eDdf4c1Ada8Bcf2da89d4bc7fB9Dd5d2"),
    {
      name: "Frontier PT-USDai PT",
      description: "Component of the Frontier PT-USDai Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x8539f99dBC4F437C1F71de6920369B9cD46193Ff"),
    {
      name: "Frontier PT-USDai USDai",
      description: "Component of the Frontier PT-USDai Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x98d6863fa1C247d529c94e53f521897ae9A6EBf0"),
    {
      name: "Frontier PT-USDai USDT0",
      description: "Component of the Frontier PT-USDai Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xCe7120C69A77E90615A9D65C581FDAc1fd311cDC"),
    {
      name: "Frontier PT-sUSDai PT",
      description: "Component of the Frontier PT-sUSDai Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x4bFcf2aCC5Cb79EE2A00D08EDfB81eFD37cC2Fe5"),
    {
      name: "Frontier PT-sUSDai sUSDai",
      description: "Component of the Frontier PT-sUSDai Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x66Ab62571Ccd31D911EeEfea85944895e30c0A3a"),
    {
      name: "Frontier PT-sUSDai USDT0",
      description: "Component of the Frontier PT-sUSDai Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x1c3073EE0d6890400D2a4c7e5338001F9bf04B3D"),
    {
      name: "Frontier YieldFi yUSD",
      description: "Component of the Frontier YieldFi Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xa1B911B8F60F87AE04Cdd4E0C4C362522927E06c"),
    {
      name: "Frontier YieldFi USDT0",
      description: "Component of the Frontier YieldFi Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xC87097cc3f4633e13DADb2adaee14145cAfB348e"),
    {
      name: "TelosC pfxSAVE",
      description: "Component of the TelosC f(x) Cluster",
      entity: "telosc",
    },
  ],
  [
    getAddress("0x38921efe4eB1dEEe78B615d968D5D66A5142b4Bf"),
    {
      name: "TelosC USDT0",
      description: "Component of the TelosC f(x) Cluster",
      entity: "telosc",
    },
  ],
  [
    getAddress("0x8Aec278c2fD4cc07B10A8865AEd33775f93EACe6"),
    {
      name: "K3 Capital Pendlend USDT0",
      description: "Component of the K3 Pendlend Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0x527295f09Ff7c411B213B29a0DE8c816a669b3fe"),
    {
      name: "K3 Capital Pendlend PT-USDe-15JAN2026",
      description: "Component of the K3 Pendlend Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0x45F4ccae775BEDd6d80c368ebA87f41D8EEf1067"),
    {
      name: "K3 Capital Pendlend PT-sUSDE-15JAN2026",
      description: "Component of the K3 Pendlend Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0x9ABBc903Af7DA20325F0C4f2fE3a77AE4e1694B4"),
    {
      name: "K3 Capital Pendlend PT-USDai-19MAR2026",
      description: "Component of the K3 Pendlend Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0x46d2CdcAE9b0369a4b4c17BA2E34e4c7D0B2832a"),
    {
      name: "K3 Capital Pendlend PT-sUSDai-19MAR2026",
      description: "Component of the K3 Pendlend Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0x003671b7Ff5CB7F5d9B7E3a0637839D8624ca5AA"),
    {
      name: "K3 Capital Pendlend PT-syrupUSDT-29JAN2026",
      description: "Component of the K3 Pendlend Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0xA4e5C5B9C7685F900cf03E26340fE25af5B666C3"),
    {
      name: "K3 Capital Pendlend WLP-USDe-15JAN2026",
      description: "Component of the K3 Pendlend Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0x3665539E0968AE000eb9E761EA89dCd9B40926Cc"),
    {
      name: "K3 Capital Pendlend WLP-sUSDE-15JAN2026",
      description: "Component of the K3 Pendlend Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0xb33D091E800a731E8609E0058C67DCbcD5ad5240"),
    {
      name: "K3 Capital Pendlend WLP-USDai-19MAR2026",
      description: "Component of the K3 Pendlend Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0x990babF76399A3fd73FBFbdd4149B968CF0C2386"),
    {
      name: "Plasma Trading Hub WXPL",
      description: "Component of the K3 Plasma Trading Hub Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0xf329a0A8548f6fB0aD1190c5AE6EFF0aE3959214"),
    {
      name: "Plasma Trading Hub USDT0",
      description: "Component of the K3 Plasma Trading Hub Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0xF90Cf999dE728A582e154F926876b70e93a747B7"),
    {
      name: "TelosC msUSD",
      description: "Component of the TelosC Stream Market",
      entity: "telosc",
    },
  ],
  [
    getAddress("0x5EFb3B2899a76e013040E85438cbe308870f5F50"),
    {
      name: "Frontier Elixir sdeUSD",
      description: "Component of the Frontier Elixir Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xD59f6112375D60e45C2BA9dd5745870c1444362F"),
    {
      name: "Frontier Elixir deUSD",
      description: "Component of the Frontier Elixir Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x3799251bD81925cfcCF2992F10Af27A4e62Bf3F7"),
    {
      name: "Frontier Elixir USDT0",
      description: "Component of the Frontier Elixir Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xF675FBe777E992f5D5D84AdF41161dC0f20104a6"),
    {
      name: "Re7 Labs xUSD USDT0",
      description: "Component of the Re7 Labs xUSD Market",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x8AdB906421f65C27155f44f1829Ca1E5B024c3F6"),
    {
      name: "Re7 Labs xUSD xUSD",
      description: "Component of the Re7 Labs xUSD Market",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x93827c26602b0573500D2eC80dB19D54EEf76BaB"),
    {
      name: "TelosC Trevee splUSD",
      description: "Component of the TelosC Trevee Market",
      entity: "telosc",
    },
  ],
  [
    getAddress("0x1aD2d433b5E95077EB2855EaB854B72eA9ee9d6c"),
    {
      name: "TelosC Trevee plUSD",
      description: "Component of the TelosC Trevee Market",
      entity: "telosc",
    },
  ],
  [
    getAddress("0xb5526491742FEe67E9E0D0D8c619A95D422fd398"),
    {
      name: "TelosC Trevee USDT0",
      description: "Component of the TelosC Trevee Market",
      entity: "telosc",
    },
  ],
  [
    getAddress("0x15F6ba87440E77C3dB462dC0f6ab797a63B94db4"),
    {
      name: "TelosC Trevee PT-splUSD-29JAN2026",
      description: "Component of the TelosC Trevee Market",
      entity: "telosc",
    },
  ],
  [
    getAddress("0x26Fef890350FbC93FE76705370793c4136dD0Aec"),
    {
      name: "TelosC Reservoir USDT0",
      description: "Component of the TelosC Reservoir Market",
      entity: "telosc",
    },
  ],
  [
    getAddress("0x20c12fa60945Aa1806b5a24Be87b1Cc5973466ee"),
    {
      name: "TelosC Reservoir wsrUSD",
      description: "Component of the TelosC Reservoir Market",
      entity: "telosc",
    },
  ],
  [
    getAddress("0x9d86B4fc23D8438fC4Aba58642DC35D5F64fE941"),
    {
      name: "K3 Yuzu USDT0 syzUSD",
      description: "Component of the K3 Yuzu Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0x2F33b4AE409e86c6BEa9E2Bbe98361c19F2A1f0c"),
    {
      name: "K3 Yuzu syzUSD",
      description: "Component of the K3 Yuzu Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0xDa33Ba72A303C26515edE275a2521b469F97D71b"),
    {
      name: "K3 Yuzu yzUSD",
      description: "Component of the K3 Yuzu Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0xFE8d21E64e0c6CFb9abF224e805452acdE8e91Fa"),
    {
      name: "K3 Yuzu USDT0 yzPP",
      description: "Component of the K3 Yuzu Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0xfc5c4e5593A352CEDc9E5D7fD4e21b321140c345"),
    {
      name: "K3 Yuzu yzPP",
      description: "Component of the K3 Yuzu Market",
      entity: "k3",
    },
  ],
  [
    getAddress("0x27934d4879fc28a74703726eDae15F757E45A48a"),
    {
      name: "TelosC plUSD",
      description: "Component of the TelosC Stream Market",
      entity: "telosc",
    },
  ],
  [
    getAddress("0x0a660B3Cbd7DF118501E7Bb0f2D6eC5E5e583Bf8"),
    {
      name: "Hyperithm USDT0",
      description: "Component of the Hyperithm USDT0 Market",
      entity: "hyperithm",
    },
  ],
  [
    getAddress("0xD833C4C39FDd2296DeB2f8fa451e0769909B4171"),
    {
      name: "Hyperithm USDT0 mHYPER",
      description: "Component of the Hyperithm USDT0 Market",
      entity: "hyperithm",
    },
  ],
  [
    getAddress("0x0FBde49D0c6FA71D097C3C6465eCD6FB49ac7efa"),
    {
      name: "Frontier PT-RLP PT-RLP-26FEB2026",
      description: "Component of the Frontier PT-RLP Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x9CbADf620185f98dd61241242089Ff5f960aDcB8"),
    {
      name: "Frontier PT-RLP RLP",
      description: "Component of the Frontier PT-RLP Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xb23377af59d4fC95cB8330eE2834Aa8241EEed03"),
    {
      name: "Frontier PT-RLP USDT0",
      description: "Component of the Frontier PT-RLP Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x4982576311a80a3D40ac5b97195F1De6C8c879C8"),
    {
      name: "Frontier PT-wstUSR PT-wstUSR-26FEB2026",
      description: "Component of the Frontier PT-wstUSR Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x1b44853e7C3b6acBA72C0B05e08B1F6aa029ff15"),
    {
      name: "Frontier PT-wstUSR USR",
      description: "Component of the Frontier PT-wstUSR Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x6A9E59545169BE88115671D7171967F8FbFfA0CD"),
    {
      name: "Frontier PT-wstUSR USDT0",
      description: "Component of the Frontier PT-wstUSR Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x54Ff34EF2503b9636b0EbD31143b9edD124E262f"),
    {
      name: "Hyperithm USDT0 PT-mHYPER-29JAN2026",
      description: "Component of the Hyperithm USDT0 Market",
      entity: "hyperithm",
    },
  ],
  [
    getAddress("0xbef0b4f89Ee840CE2aC4e96ea37e807aE4F35231"),
    {
      name: "Alphaping YieldFi vyUSD",
      description: "Component of the Alphaping YieldFi VYUSD Market",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x51d03b57f916EAf631892702A32a5378b93a6998"),
    {
      name: "Alphaping YieldFi USDT0",
      description: "Component of the Alphaping YieldFi VYUSD Market",
      entity: "euler-dao",
    },
  ],
])
